import React, { useState, useEffect } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Title from "../../../layout/Title/Title";
import "./categoriaProductos.css";

const CategoriaProductos = ({ data, urlMainData }) => {
  const { categorySlug } = useParams();
  const navigate = useNavigate();
  const [clientData, setClientData] = useState([]);
  const [category, setCategory] = useState(null);

  useEffect(() => {
    setClientData(data);
  }, [data]);

  useEffect(() => {
    if (clientData.length > 0) {
      const foundCategory = clientData.find(cat => cat.slug === categorySlug);
      if (!foundCategory) {
        console.warn("🚫 Categoría no encontrada. Redireccionando a /404...");
        navigate("/404");
      } else {
        setCategory(foundCategory);
      }
    }
  }, [clientData, categorySlug, navigate]);

  const strapiBase = process.env.REACT_APP_STRAPI_API_BASE.replace("/api", "");

  if (!category) return null;

  return (
    <>
      <Title text={category.category} />
      <div className="container container-category-products">
        <div className="row">
          {category.products.map((product, index) => {
            const imageUrl = `${strapiBase}${product.images?.[0]?.urlMobile || "/assets/imgs/default-product.jpg"}`;
            return (
              <div key={index} className="col-md-4">
                <div className="card product-card">
                  <Link to={`${urlMainData}/${categorySlug}/${product.slug}`} className="product-card-link">
                    <div
                      className="card-img-top"
                      style={{ backgroundImage: `url(${imageUrl})` }}
                    ></div>
                    <div className="card-body">
                      <h5 className="card-title">{product.images?.[0]?.title || 'Sin título'}</h5>
                    </div>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default CategoriaProductos;
